import api from "../api/client";

export async function fetchInvoice(orderId) {
  const response = await api.get(`/api/orders/${orderId}/invoice`);
  return response.data;
}

export async function downloadInvoice(orderId) {
  const data = await fetchInvoice(orderId);
  const html = `
    <!doctype html>
    <html>
      <head>
        <meta charset="utf-8" />
        <title>${data.invoiceNumber}</title>
      </head>
      <body>${data.invoiceHtml}</body>
    </html>
  `;

  const blob = new Blob([html], { type: "text/html" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `${data.invoiceNumber}.html`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}
